var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFEBE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05874 8.10154C8.38933 8.07874 8.6758 8.32825 8.6986 8.65884L9.22154 16.2414C9.24323 16.556 9.50477 16.8001 9.82012 16.8001H14.1799C14.4953 16.8001 14.7568 16.556 14.7785 16.2414L15.3014 8.65884C15.3242 8.32825 15.6107 8.07874 15.9413 8.10154C16.2719 8.12434 16.5214 8.41082 16.4986 8.7414L15.9757 16.324C15.9106 17.2678 15.126 18.0001 14.1799 18.0001H9.82012C8.87407 18.0001 8.08947 17.2678 8.02438 16.324L7.50145 8.7414C7.47865 8.41082 7.72816 8.12434 8.05874 8.10154Z",
    fill: "#BF2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59961 8.3998C6.59961 8.06843 6.86824 7.7998 7.19961 7.7998H16.7996C17.131 7.7998 17.3996 8.06843 17.3996 8.3998C17.3996 8.73118 17.131 8.9998 16.7996 8.9998H7.19961C6.86824 8.9998 6.59961 8.73118 6.59961 8.3998Z",
    fill: "#BF2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 7.2C11.3369 7.2 10.7996 7.73726 10.7996 8.4C10.7996 8.73137 10.531 9 10.1996 9C9.86824 9 9.59961 8.73137 9.59961 8.4C9.59961 7.07452 10.6741 6 11.9996 6C13.3251 6 14.3996 7.07452 14.3996 8.4C14.3996 8.73137 14.131 9 13.7996 9C13.4682 9 13.1996 8.73137 13.1996 8.4C13.1996 7.73726 12.6624 7.2 11.9996 7.2Z",
    fill: "#BF2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete_red.b9523136bcc96063cf36a3aeb84bc3c0.svg";
export { ForwardRef as ReactComponent };